import CaladreTheme from "theme/Theme";
import sharedStyle from "../style";

const classes = {
  ...sharedStyle,
  noMouse: {
    '& *': {
      cursor: 'default'
    }
  },
  emptyPasseport: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    "& .MuiGrid-item": {
      padding: 1,
    },
    "& .MuiCard-root": {
      display: "block !important",
      margin: "0 !important",
      p: 3,
    },
    "& .MuiList-root": {
      "& .MuiAvatar-root": {
        width: "28px",
        height: "28px",
        backgroundColor: CaladreTheme.palette.primary.main,
      },
      "& .MuiListItem-root": {
        alignItems: "start",
        padding: 0,
        margin: "20px 0",
        "& .MuiListItemText-root": {
          m: 0,
          "& .MuiTypography-root": {
            fontSize: "14px",
          },
        },
        "& .MuiListItemAvatar-root": {
          minWidth: 22,
        },
        "& .MuiAvatar-root ": {
          width: 22,
          height: 22,
          marginRight: CaladreTheme.spacing(0.8),
          backgroundColor: CaladreTheme.palette.primary.main,
          "& .MuiSvgIcon-root": {
            fontSize: "14px",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              transform: "scale(1.1)",
            },
          },
        },
      },
    },
    "& .MuiImageList-root ": {
      gap: "10px !important",
      margin: 0,
      width: "100%",
      height: "100%",
      "& .MuiImageListItem-root:first-child img": {
        borderTopLeftRadius: "15px",
        borderTopRightRadius: "15px",
      },
      "& .MuiImageListItem-root:nth-of-type(2) img": {
        borderBottomLeftRadius: "15px",
      },
      "& .MuiImageListItem-root:last-child img": {
        borderBottomRightRadius: "15px",
      },
    },
  },
  profileAvatar: {
    width: "120px",
    height: "120px",
  },
  editIcon: {
    padding: "0 !important",
    color: `${CaladreTheme.palette.primary.main} !important`,
    fontSize: "32px !important",
  },
  uploadAvatar: {
    position: "absolute",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "30px",
    width: "120px",
    borderRadius: "0 0 50% 50%/0 0 100% 100%",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
      color: "#FFF",
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  profileBloc: {
    "& .MuiListItemText-secondary span": {
      fontSize: "12px !important",
      color: CaladreTheme.custom.Black,
    },
    "& .MuiListItemSecondaryAction-root": {
      top: "10px",
    },
  },
  parametres: {
    "& .MuiTypography-body2": {
      color: CaladreTheme.custom.Black,
    },
    "& .MuiButton-root": {
      fontSize: "12px !important",
      color: `${CaladreTheme.custom.White} !important`,
      "&:hover": {
        color: `${CaladreTheme.palette.primary.main} !important`,
      },
    },
  },
  imageListBloc: {
    position: "relative",
    "& .MuiIconButton-root": {
      position: "absolute",
      top: "48px",
      right: "48px",
      zIndex: 999,
    },
  },
};
export default classes;
